var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "birds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 54,
    x2: 22,
    y2: 30,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.032,16.673A11.868,11.868,0,0,0,30,12c0-5.523-3.582-10-8-10s-8,4.477-8,10a11.868,11.868,0,0,0,.968,4.673A14.8,14.8,0,0,0,10,28c0,7.732,5.373,14,12,14s12-6.268,12-14A14.8,14.8,0,0,0,29.032,16.673Z",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 54,
    x2: 42,
    y2: 32,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,40.251A10.632,10.632,0,0,0,42,42c6.627,0,12-6.268,12-14a14.8,14.8,0,0,0-4.968-11.327A11.868,11.868,0,0,0,50,12c0-5.523-3.582-10-8-10-2.876,0-5.377,1.913-6.787,4.761",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96,40.484A48.3,48.3,0,0,0,2,44.542V62H62V44.542a48.3,48.3,0,0,0-5.96-4.058",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirds);
export default __webpack_public_path__ + "static/media/birds.52aa0023b4708aa8bbec1b2fced34bf7.svg";
export { ForwardRef as ReactComponent };